import { getAuth, verifyPasswordResetCode } from '@firebase/auth';
import { Button, TextField } from '@mui/material';
import { confirmPasswordReset } from 'firebase/auth';
import React, { useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Link, useNavigate, useSearchParams } from 'react-router';
import { getAuthErrorMessageForCode, handleError } from '../../../common/firebase/auth-error.service';
import { passwordRegex } from '../../../common/firebase/regex';
import { severity } from '../../../common/models/severity.enum';
import { isProdOrDevEnv } from '../../../environment.enum';
import { ServiceManager } from '../../../services/service-manager';
import styles from './ResetPassword.module.css';

const ResetPassword = () => {

    const codeQueryParam = 'oobCode'
    const [searchParams] = useSearchParams();
    const [showPwdForm, setShowPwdForm] = useState<boolean>(false);
    const { register, handleSubmit, formState: { errors } } = useForm<{ password: string }>();
    const firstRenderRef = useRef(true);

    const navigate = useNavigate();

    useEffect(() => {
        if (!isProdOrDevEnv() && firstRenderRef.current) {
            firstRenderRef.current = false;
            return;
        }

        const auth = getAuth();
        verifyPasswordResetCode(auth, searchParams.get(codeQueryParam))
            .then(() => {
                setShowPwdForm(true);
            })
            .catch((err) => {
                handleError(err);
            })
    }, [searchParams])

    const onSubmit = (data) => {
        const auth = getAuth();
        confirmPasswordReset(auth, searchParams.get(codeQueryParam), data.password).then(() => {
            ServiceManager.snackbarService.openSnackbar('Uw wachtwoord is aangepast.', severity.success, 3000);
            navigate('/auth/login');
        }).catch((err) => {
            handleError(err);
        });
    }

    return (
        <div className={styles.ResetPassword} data-testid="ResetPassword">
            {showPwdForm ? (<>
                <form data-testid="reset-password-form" onSubmit={handleSubmit(onSubmit)}>
                    <div>
                        <TextField id="reset-password-password"
                            fullWidth
                            className="form-input"
                            label="Wachtwoord"
                            {...register('password', { required: { value: true, message: 'U moet uw nieuwe wachtwoord invullen.' }, pattern: { value: passwordRegex, message: 'Het wachtwoord moet minimaal 8 karakters, 2 hoofdletters, 1 speciaal teken, 2 cijfers en 3 kleine letters bevatten.' } })}
                            variant="standard"
                            type="password"
                        />
                        {errors.password && <p className="field-error">{errors.password.message}</p>}
                    </div>
                    <Button color="secondary" data-testid="reset-password-submit" size="small" variant="outlined" type="submit">Wachtwoord Wijzigen</Button>
                </form>
            </>) : (<>
                <p>
                    Vraag opnieuw een verificatie link aan op de pagina <Link className="page-scroll" to="/auth/forgot-password">Wachtwoord vergeten</Link>
                </p>
                <p>
                    Nog geen account? <Link className="page-scroll" to="/auth/signup">Maak een nieuwe aan</Link>
                </p>
            </>)}
        </div>
    )
};

export default ResetPassword;
